import React from 'react';
import PropTypes from 'prop-types';

import {
  makeStyles,
  Chip,
  Grid,
  darken
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  list: {
    border: '1px solid rgba(0,0,0,0.1)',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2,1),
  },
  item: {
    padding: theme.spacing(0.5,1.5)
  },
  chip: {
    backgroundColor: theme.palette.primary[50],
    justifyContent: 'space-between',
    width: '100%',

    '&.MuiChip-colorSecondary': {
      backgroundColor: 'rgba(233, 233, 233, 0.6)',
      color: 'rgba(0, 0, 0, 0.6)',
      '& .MuiChip-deleteIcon': {
        color: theme.palette.primary.main,
        transform: 'rotate(45deg)',
        transition: 'all 0.2s linear',
      }
    },
    '&.MuiChip-colorSecondary:focus': {
      backgroundColor: 'rgba(233, 233, 233, 0.8)',
    },
    '&:focus': {
      backgroundColor: darken(theme.palette.primary[50], 0.1)
    },

    '& .MuiChip-deleteIcon': {
      color: 'rgba(0, 0, 0, 0.87)',
      transform: 'rotate(0deg)',
      transition: 'all 0.2s linear',

      '&:hover': {
        color: 'rgba(0, 0, 0, 0.67)'
      },
    }
  }
}));

const DeleteList = props => {
  const classes = useStyles();

  return (
    <div className={classes.list}>
      <Grid container>
        {props.items.map((item, index) =>
          <Grid item xs={12} sm={12} md={6} lg={4} xl={3} key={typeof item.value === 'object' ? JSON.stringify(item.value) : String(item.value)} className={classes.item}>
            <Chip color={item.excluded ? 'secondary': 'default'} label={item.label} onDelete={(e) => props.onDelete({value: item.value, excluded: item.excluded})} classes={{root: classes.chip}} disabled={props.disabled} />
          </Grid>
        )}
      </Grid>
    </div>
  );
};

DeleteList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    excluded: PropTypes.bool
  })),
  onDelete: PropTypes.func,
  disabled: PropTypes.bool
}

export default DeleteList;
